import { ref, computed } from 'vue';

const isOpen = ref(false);
const activeChapterId = ref(null);

export function useHelp() {
  return {
    isOpen,
    activeChapterId,
    open(chapterId = null) {
      if (chapterId) activeChapterId.value = chapterId;
      isOpen.value = true;
    },
    close() {
      isOpen.value = false;
    },
    toggle(chapterId = null) {
      if (chapterId) activeChapterId.value = chapterId;
      isOpen.value = !isOpen.value;
    },
    isActive: computed(() => isOpen.value),
  };
}
